/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Admin_OnlyInputs */

const cs_automation_admin_only = /** @type {(inputs: Automation_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatizace je dostupná pouze administrátorům.`)
};

const en_automation_admin_only = /** @type {(inputs: Automation_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation is available to admins only.`)
};

/**
* | output |
* | --- |
* | "Automation is available to admins only." |
*
* @param {Automation_Admin_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_admin_only = /** @type {((inputs?: Automation_Admin_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Admin_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_admin_only(inputs)
	return cs_automation_admin_only(inputs)
});